import { jsx as a } from "react/jsx-runtime";
import { QUERIES as k, BREAKPOINTS as h } from "@fcamna/shared-component-foundations";
import m from "styled-components";
import "react";
import { u as f } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { SingleSelectInput as $ } from "./multiSelectInput.js";
import { u as T } from "./useWindowDimensions-ae69e913.mjs";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./combineRefs-90f27925.mjs";
import "./index-2be68378.mjs";
import "react-dom";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./icon.js";
import "@fcamna/shared-icons";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./helperText-d9646f54.mjs";
import "./menu.js";
import "./textInput.js";
import "./radio.js";
import "./tags.js";
import "./childrenCountCheck-785fa19a.mjs";
import "./screenReaderOnly-fd82ed96.mjs";
const j = m.div`
  display: ${(e) => e.theme.components.jumplink.TabsHeader.display};
  flex-direction: ${(e) => e.theme.components.jumplink.TabsHeader.flexDirection};

  max-width: ${(e) => e.theme.components.jumplink.TabsHeader.maxWidth};

  @media ${k.tabletAndUp} {
    max-width: ${(e) => e.theme.components.jumplink.TabsHeader.tabletAndUp.maxWidth};
  }
`, L = m.span`
  display: ${(e) => e.theme.components.jumplink.TabWrapper.display};
  width: ${(e) => e.theme.components.jumplink.TabWrapper.width};
  box-sizing: ${(e) => e.theme.components.jumplink.TabWrapper.boxSizing};
  align-items: ${(e) => e.theme.components.jumplink.TabWrapper.alignItems};
  flex-shrink: ${(e) => e.theme.components.jumplink.TabWrapper.flexShrink};
  padding: ${(e) => e.theme.components.jumplink.TabWrapper.padding};
  border-left: ${(e) => e.theme.components.jumplink.TabWrapper.borderLeft};

  &:focus-visible {
    outline: ${(e) => e.theme.components.jumplink.TabWrapper.focusVisible.outline};
    border-radius: ${(e) => e.theme.components.jumplink.TabWrapper.focusVisible.borderRadius};
    outline-offset: ${(e) => e.theme.components.jumplink.TabWrapper.focusVisible.outlineOffset};
    position: ${(e) => e.theme.components.jumplink.TabWrapper.focusVisible.position};
    z-index: ${(e) => e.theme.components.jumplink.TabWrapper.focusVisible.zIndex};
  }
  border-left: ${({ $isActive: e, theme: p, $isDisabled: n }) => e && !n ? p.components.jumplink.TabWrapper.borderLeftActive : p.components.jumplink.TabWrapper.borderLeftInActive};
  cursor: ${({ $isDisabled: e, ...p }) => e ? p.theme.components.jumplink.TabWrapper.cursor.disabled : p.theme.components.jumplink.TabWrapper.cursor.default};

  &:hover {
    ${({ $isActive: e, $isDisabled: p, theme: n }) => !p && `border-left:${e ? n.components.jumplink.TabWrapper.hover.borderLeftActive : n.components.jumplink.TabWrapper.hover.borderLeftInActive};
      background-color: ${n.components.jumplink.TabWrapper.hover.backgroundColor};
      cursor: ${n.components.jumplink.TabWrapper.hover.cursor};
      z-index: ${n.components.jumplink.TabWrapper.hover.zIndex};
      `}
  }
`, W = m.span`
  text-align: ${(e) => e.theme.components.jumplink.TabLabel.textAlign};
  font-family: ${(e) => e.theme.components.jumplink.TabLabel.fontFamily};
  font-style: ${(e) => e.theme.components.jumplink.TabLabel.fontStyle};
  font-size: ${(e) => e.theme.components.jumplink.TabLabel.fontSize};
  font-weight: ${(e) => e.theme.components.jumplink.TabLabel.fontWeight};
  color: ${({ $isActive: e, $isDisabled: p, theme: n }) => p ? n.components.jumplink.TabLabel.color.disabled : e ? n.components.jumplink.TabLabel.color.active : n.components.jumplink.TabLabel.color.default};
  cursor: ${({ $isDisabled: e, theme: p }) => e ? p.components.jumplink.TabLabel.cursor.disabled : p.components.jumplink.TabLabel.cursor.default};
  display: ${(e) => e.theme.components.jumplink.TabLabel.display};
  align-items: ${(e) => e.theme.components.jumplink.TabLabel.alignItems};
  width: ${(e) => e.theme.components.jumplink.TabLabel.width};
  line-height: ${(e) => e.theme.components.jumplink.TabLabel.lineHeight};
  overflow: ${(e) => e.theme.components.jumplink.TabLabel.overflow};
  text-overflow: ${(e) => e.theme.components.jumplink.TabLabel.textOverflow};
  display: ${(e) => e.theme.components.jumplink.TabLabel.displayWebkitBox};
  -webkit-line-clamp: ${(e) => e.theme.components.jumplink.TabLabel.webkitLineClamp}; /* Limit to 3 lines */
  -webkit-box-orient: ${(e) => e.theme.components.jumplink.TabLabel.webkitBoxOrient};
`, ce = ({
  activeJumpLink: e = 0,
  setActiveJumpLink: p,
  jumplinks: n = []
}) => {
  const c = f({ label: "Jump Link" }), { width: d } = T(), s = (i, r) => {
    i || p(r);
  }, u = (i) => {
    let r = 0;
    n.forEach((l, o) => {
      if (l.label === (i == null ? void 0 : i.label)) {
        r = o;
        return;
      }
    }), p(r);
  };
  return /* @__PURE__ */ a(
    j,
    {
      ...c,
      role: "tablist",
      children: n && (() => {
        var l;
        const i = /* @__PURE__ */ a(
          $,
          {
            placeholder: "Select...",
            options: n.map((o) => ({
              label: o == null ? void 0 : o.label,
              value: o == null ? void 0 : o.label,
              disabled: o == null ? void 0 : o.disabled
            })),
            selected: `${(l = n[e]) == null ? void 0 : l.label}`,
            onOptionSelect: u,
            size: "medium",
            maxItems: 6
          }
        ), r = n.map((o, t) => t >= 8 ? null : /* @__PURE__ */ a(
          L,
          {
            role: "tab",
            $isActive: e === t,
            "aria-selected": e === t,
            "data-focus": e === t,
            onClick: () => s(o.disabled, t),
            tabIndex: 0,
            $isDisabled: (o == null ? void 0 : o.disabled) || !1,
            onKeyDown: (b) => {
              (b.code === "Enter" || b.code === "Space") && s(o.disabled, t);
            },
            "aria-disabled": o.disabled,
            "data-testid": "Jumplink-testid",
            ...o.accessibilityOptions,
            children: /* @__PURE__ */ a(
              W,
              {
                $isDisabled: (o == null ? void 0 : o.disabled) || !1,
                $isActive: e === t,
                children: o.label
              }
            )
          },
          `${o.label.toLocaleLowerCase()}-${t}`
        ));
        return d < h.tabletMin ? i : r;
      })()
    }
  );
};
export {
  ce as JumpLink
};
